import defaultState from '@/store/modules/auctions/defaultState';
import SavedAuction from '@/models/SavedAuction';
import SavedAuctionClient from '@/api/SavedAuctionClient';

const moduleKey = 'MyAcvSaved';
const actions = {
  async getMyAcvSavedAuctions({
    commit,
    state,
  }, { page = 1 }) {
    try {
      let auctions = [];

      // TODO: filter auctions in store to filtered id and append loaders?
      // first load with new dealer filter, clear
      if (this.state.auctions[moduleKey].auctions.length > 0 && page === 1) {
        commit('setAuctions', { moduleKey, auctions: [] });
      }

      commit('setLoading', true);
      commit('addLoadingAuctions', {
        count: 10,
        moduleKey,
      });
      const params = {
        all_dealers: this.state.auctions.filters.dealer_ids === -1,
        from: (page - 1) * state.filters.pagination.size,
        size: state.filters.pagination.size,
      };

      const { hasMultipleDealerships, defaultDealerId } = this.state.authorization.user;

      const useBff = this.state.featureFlags?.flags?.show_offers_on_saved_auctions_screen ?? false;

      if (useBff || this.state.auctions.filters.dealer_ids !== -1) {
        if (this.state.auctions.filters.dealer_ids > 0) {
          params.dealer_ids = this.state.auctions.filters.dealer_ids;
        } else if (useBff || hasMultipleDealerships) {
          params.dealer_ids = defaultDealerId;
        }
      }

      if (state.filters.query !== '') {
        params.query = state.filters.query;
      }

      const client = new SavedAuctionClient(this.state.authorization.user);
      const response = await client.getList(params);
      const { dealerships } = this.state.authorization.user;
      const responseData = response.data?.saved_auctions || response.data.data?.saved_auctions;
      auctions = responseData.map((auction) => new SavedAuction(auction, dealerships));

      if (responseData) {
        let action = 'setAuctions';

        if (page > 1) {
          action = 'addAuctions';
        }
        commit(action, {
          auctions,
          moduleKey,
        });
        commit('setPagination', {
          pagination: response.data.pagination || response.data.data.pagination,
          moduleKey,
        });
      }
      return auctions;
    } catch (error) {
      commit('setError', error);
    } finally {
      commit('removeLoadingAuctions', moduleKey);
      commit('setLoading', false);
    }
    return null;
  },
};

export default {
  state: defaultState,
  actions,
};
